import useTranslation from "utils/hooks/useTranslation";

export const ElelctricAppontBlock: React.FC<{ solution: Solution }> = ({
  solution,
}) => {
  const { t } = useTranslation();
  return (
    <group
      data-length="260"
      data-height="50"
      data-border="inset"
      data-space-horizontal="10"
      data-align="center"
      data-justify="center"
      //data-background="red"
    >
      <text
        //data-position="center"

        data-color="grey-color-dark"
        data-weight="400"
      >
        {solution.appoint?.puissance_totale}
        {t("FO_UNIT_KW")}
      </text>
    </group>
  );
};
